import { styled } from "@mui/material/styles";

import { ShipmentType } from "../../../../../../util/enums";

interface ShipmentTypeProps {
  type: string;
}
export const ShipmentTypeStyles = styled("span")(({ type }: ShipmentTypeProps) => ({
  color: type === ShipmentType.SEA ? "#20639d" : "#38cfc4",
  fontWeight: 400,
  fontFamily: "Manrope",
}));

interface CompactProps {
  compact?: boolean;
}

export const EmptyContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "compact",
})(({ compact }: CompactProps) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  gap: compact ? 16 : 32,
  minHeight: compact ? "160px" : "50vh",
  height: compact ? "auto" : "calc(100vh - 525px)",
  "& img": {
    width: compact ? "140px" : "250px",
  },
}));

export const EmptyTitle = styled("span")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "1.5rem",
  fontWeight: 500,
  lineHeight: "130%",
}));

export const ButtonsWrapper = styled("div")(() => ({
  position: "absolute",
  bottom: 0,
  right: 0,
}));

interface WrapperProps {
  isOnViewMode: boolean;
  compact?: boolean;
}
export const Wrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "isOnViewMode" && prop !== "compact",
})(({ isOnViewMode, compact }: WrapperProps) => ({
  position: "relative",
  paddingBottom: compact ? 0 : "2.5rem",
  minHeight: compact || isOnViewMode ? "" : "calc(100vh - 300px)",
}));

export const Header = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const HeaderTitle = styled("span")(() => ({
  color: "#1D2939",
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "1.125rem",
  lineHeight: "150%",
}));

export const ButtonLabel = styled("span")(() => ({
  fontFamily: "Inter",
  fontSize: "0.75rem",
  fontWeight: 700,
  marginLeft: "0.75rem",
}));
